import { FaCheck } from "react-icons/fa6";
import { useEffect, useState } from 'react'
import Reviews from '../courses/CoursesSingle/Reviews';
import VideoPlayer from "./VideoPlayer";
import { lessonsService } from "../../services/lesson";


const lessontemp = {
  title: "Introduction to UX Design",
  description: "In this lesson, we will explore the fundamentals of UX design, including user research, wireframing, and prototyping. You will learn how to create user-centered designs that enhance the overall user experience.",
  videoUrl: "https://docs.material-tailwind.com/demo.mp4",
  learnItems: [
    "Become a UX designer.", "You will be able to add UX designer to your CV",
    "Become a UI designer.", "Build & test a full website design.", "Create your first UX brief & persona.",
    "How to use premade UI kits.", "Create quick wireframes.", "Downloadable exercise files",
    "Build a UX project from beginning to end.", "Learn to design websites & mobile phone apps.",
    "All the techniques used by UX professionals", "You will be able to talk correctly with other UX design."
  ]
}

function MainContent({ lessonId }) {
  const [lesson, setLesson] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showFullDescription, setShowFullDescription] = useState(false);

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  // Fonction pour récupérer les détails d'une leçon
  const fetchLessonDetails = async (lessonId) => {
    try {
      setLoading(true);
      // const response = await lessonsService.getLessonsById(lessonId);

      // if (response.success) {
      //   setLesson(response.data);
      //   console.log("Lesson data:", response.data);
      // } else {
      //   setError(response.message || 'Erreur lors du chargement de la leçon');
      // }
      setLesson(lessontemp); // a supprimer une fois l'API opérationnelle
      lesson.id = lessonId;
    } catch (err) {
      setError('Erreur de connexion au serveur');
      console.error('Erreur:', err);
    }
  };

  useEffect(() => {
    if (lessonId) {
      fetchLessonDetails(lessonId);
    }
  }, [lessonId]);

  lesson.id = lessonId;

  console.log("Lesson state:", lesson);

  const learnItems = lesson.learnItems || [];
  const half = Math.ceil(learnItems.length / 2);

  useEffect(() => {
    if (lesson) {
      setLoading(false);
    }
  }, [lesson]);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-64">
        <div className="text-red-500 dark:text-red-400">{error}</div>
      </div>
    );
  }

  if (!lesson) {
    return (
      <div className="flex justify-center items-center min-h-64">
        <div className="text-gray-600 dark:text-gray-300">Leçon non trouvé</div>
      </div>
    );
  }

  return (
    <main className="flex-1 bg-white px-4 lg:pl-[540px] lg:pr-[90px] pt-8 lg:pt-[70px] pb-16 lg:pb-32 font-sans h-full dark:bg-dark-2">
      <VideoPlayer />

      <div className='mt-8 lg:mt-14'>
        <h4 className='text-dark-2 dark:text-white font-sans text-lg'>Description</h4>
        <div className="relative mt-6">
          <div
            className={`text-gray-600 dark:text-gray-300 transition-all duration-500 ease-in-out
                  overflow-hidden ${showFullDescription ? 'max-h-[1000px]' : 'max-h-[180px]'}`}
          >
            <p>
              {lesson.description}
            </p>
          </div>

          {/* Overlay de dégradé */}
          {!showFullDescription && (
            <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent
               dark:from-dark-5 dark:to-transparent pointer-events-none"></div>
          )}
        </div>
        {/* Overlay de dégradé */}
        {!showFullDescription && (
          <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent
               dark:from-dark-5 dark:to-transparent pointer-events-none"></div>
        )}
        <button
          onClick={toggleDescription}
          className="text-purple-1 dark:text-purple-1 font-medium underline mt-2 flex items-center
            dark:hover:text-purple-300 transition-colors"
        >
          {showFullDescription ? (
            <>
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
              </svg>
              Show Less
            </>
          ) : (
            <>
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
              Show More
            </>
          )}
        </button>
      </div>

      <div className='mt-8 lg:mt-14'>
        <h4 className='text-dark-2 dark:text-white font-semibold text-lg lg:text-xl'>What you'll learn</h4>
        <div className="mt-4 lg:mt-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-4">
              {learnItems.slice(0, half).map((items, index) => (
                <div key={index} className='flex items-start'>
                  <FaCheck className='w-fit p-1 mr-2 border border-gray-300 rounded-full mt-1 flex-shrink-0' />
                  <p className="text-gray-500 dark:text-gray-300 text-sm lg:text-[15px] font-sans">{items}</p>
                </div>
              ))}
            </div>
            <div className="space-y-4">
              {learnItems.slice(half).map((items, index) => (
                <div key={index} className='flex items-start'>
                  <FaCheck className='w-fit p-1 mr-2 border border-gray-300 rounded-full mt-1 flex-shrink-0' />
                  <p className="text-gray-500 dark:text-gray-300 text-sm lg:text-[15px] font-sans">{items}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className='mt-8 lg:mt-14'>
        <h4 className='text-dark-2 dark:text-white font-semibold text-lg lg:text-xl'>Requirements</h4>
        <div className="mt-4 lg:mt-8">
          <ul className="pl-4 lg:pl-[1.06667rem] gap-y-4 list-disc text-gray-500 dark:text-gray-300 text-sm lg:text-[15px] font-sans">
            <li className='mt-2 lg:mt-4'>You will need a copy of Adobe XD 2019 or above. A free trial can be downloaded from Adobe.</li>
            <li className='mt-2 lg:mt-4'>No previous design experience is needed.</li>
            <li className='mt-2 lg:mt-4'>No previous Adobe XD skills are needed.</li>
          </ul>
        </div>
      </div>

      <div className='mt-8 lg:mt-14'>
        <Reviews />
      </div>
    </main>
  )
}

export default MainContent